import { Icons } from 'greener-ui-library';
import { PROJECT_TYPES } from 'utils/constants';

export type ApplicationType = string;

export const applicationTypes = [
  {
    value: PROJECT_TYPES.infrastructureSite,
    icon: <Icons.AddRoad />,
    label: 'entities:projectType.values.infrastructure_site',
  },
  {
    value: PROJECT_TYPES.construction,
    icon: <Icons.Construction />,
    label: 'entities:projectType.values.construction',
  },
  {
    value: PROJECT_TYPES.gridDeferral,
    icon: <Icons.Domain />,
    label: 'entities:projectType.values.grid_deferral',
  },
  {
    value: PROJECT_TYPES.event,
    icon: <Icons.FestivalOutlined />,
    label: 'entities:projectType.values.event',
  },
  {
    value: PROJECT_TYPES.other,
    icon: <Icons.More />,
    label: 'entities:projectType.values.other',
  },
];